import HomePage from '../components/HomePage'
import StaticPage from './../components/StaticPage'
import LoginPage from '../components/LoginPage'
import HashLogin from '../components/HashLogin'
import CurrentOrders from '../components/ms_modern_reporting/current_orders'
import Orders from '../components/ms_modern_reporting/warranties'
import OrderDetail from '../components/ms_modern_reporting/warranties/OrderDetails'
import Customers from '../components/ms_modern_reporting/customers'
import Customer from '../components/ms_modern_reporting/customers/CustomerForm'
import CurrentOrderDetails from '../components/ms_modern_reporting/current_orders/details'
import IntroductionAndContact from '../components/MSSurfaceZone/introductionAndContact'
import PromotionsNewsEvents from '../components/MSSurfaceZone/promotionsNewsEvents'
import SurfacePartner from '../components/MSSurfaceZone/surfacePartner'
import SurfaceProducts from '../components/MSSurfaceZone/surfaceProducts'
import UsefulMaterial from '../components/MSSurfaceZone/usefulMaterial'
import SurfaceResellerAllianceProgram from '../components/MSSurfaceZone/surfaceResellerAllianceProgram'


import { _t } from '../i18n/lang'

export const ROUTES = [
  {
    path: '/',
    name: 'HOME-PAGE',
    exact: true,
    component: SurfacePartner,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/introduction-and-contact',
    name: 'INTRODUCTION_AND_CONTACT',
    exact: true,
    component: IntroductionAndContact,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/surface-commercial-partner',
    name: 'SURFACE_COMMERCIAL_PARTNER',
    exact: true,
    component: SurfacePartner,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/surface-products',
    name: 'SURFACE_PARTNERS',
    exact: true,
    component: SurfaceProducts,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/promotions-news-events',
    name: 'PROMOTIONS_NEWS_EVENTS',
    exact: true,
    component: PromotionsNewsEvents,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/useful-materials',
    name: 'USEFUL_MATERIALS',
    exact: true,
    component: UsefulMaterial,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/surface-reseller-alliance-program',
    name: 'SURFACE_RESELLER_ALLIANCE_PROGRAM',
    exact: true,
    component: SurfaceResellerAllianceProgram,
    fetch: true,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/login',
    name: 'LOGIN',
    component: LoginPage,
    loginRequired: false,
    withoutTemplate: false
  },
  {
    path: '/hash-login/:hash',
    name: 'HASH-LOGIN',
    component: HashLogin,
    loginRequired: 'both',
    withoutTemplate: true
  },
  {
    path: '/page/:page',
    name: 'STATICPAGE',
    component: StaticPage,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/current-orders',
    name: 'current_orders',
    component: CurrentOrders,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/current-order/:id',
    name: 'current_order_details',
    component: CurrentOrderDetails,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/order/:id',
    name: 'order_details',
    component: OrderDetail,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    loginRequired: true,
    withoutTemplate: false
  },
  {
    path: '/customer/:id',
    name: 'update_customer',
    component: Customer,
    loginRequired: true,
    withoutTemplate: false
  },
]

export const ROUTES_BY_ID = (function () {
  const result = {}
  ROUTES.forEach((element) => {
    result[element.name] = element
  })
  return result
}())
